import { createTheme } from "@mui/material/styles";

export const lightTheme = createTheme({
  // body: {
  //   backgroundColor: "#F2F2F2 !important",
  //   color: "#4c5b5c"
  // },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: ({ theme }) => ({
          "&.Mui-disabled": {
            opacity: 1,
            "-webkit-text-fill-color": theme.palette.grey.dark+' !important',
            pointerEvents: "auto"
          }
        })
      }
    }
  },
  typography: {
   fontFamily: `futura-pt, "Helvetica", "Arial", sans-serif`,
   fontSize: 16,
   // "fontWeightLight": 300,
   // "fontWeightRegular": 400,
   // "fontWeightMedium": 500
  },
  paper: {
    root: {
      borderRadius: '15px',
    },
  },
  palette: {
    mode: 'light',
    type: 'light',
    common: {
      black: '#000',
      grey: '#aaa',
      green: '#2ecc71',
      white: '#fff'
    },
    primary: {
      light: '#0088db',
      main: '#0078c1',
      dark: '#0068a8',
      darker: '#00588e',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7fad',
      //main: '#f50057',
      //dark: '#c51162',
      main: '#d7136b',
      dark: '#ae0f56',
      contrastText: '#fff',
    },
    error: {
      lighter: '#ed9e9e',
      light: '#e57373',
      main: '#f44336',
      dark: '#d32f2f',
      contrastText: '#fff',
    },
    warning: {
      light: '#FFAD82',
      main: '#ff8c4f',
      dark: '#FF6B1C',
      contrastText: '#fff',
    },
    info: {
      light: '#469af5',
      main: '#2185f3',
      dark: '#0c72e0',
      contrastText: '#fff',
    },
    grey: {
      light: '#5e7071',
      main: '#4c5b5c',
      dark: '#3a4647',
      darkest: '#000',
      contrastText: '#fff',
    },
    ltgrey: {
      light: '#efefef',
      main: '#dfdfdf',
      dark: '#a1a1a1',
      contrastText: '#000',
    },
    employ: {
      light: '#dffcfd',
      main: '#10c8cd',
      dark: '#0da4a9',
      contrastText: '#fff',
    },
    incorp: {
      light: '#feeece',
      main: '#f9ac0f',
      dark: '#db9505',
      contrastText: '#fff',
    },
    ltblue: {
      // light: '#64b5f6',
      main: '#4bbbff',
      // dark: '#1976d2',
      contrastText: '#000',
    },
    bgblue: {
      // light: '#64b5f6',
      main: '#F2F6FF',
      // dark: '#1976d2',
      contrastText: '#000',
    },
    bggrey: {
      // light: '#64b5f6',
      main: '#fafafa',
      // dark: '#1976d2',
      contrastText: '#000',
    },
    tablehead: {
      main: '#fff',
      contrastText: '#000',
    },
    tablerow: {
      main: '#efefef',
      dark: '#a1a1a1',
      contrastText: '#000',
    },
    tablerowalt: {
      main: '#dfdfdf',
      contrastText: '#000',
    },
    appBar: {
      main: '#fff',
      contrastText: '#4c5b5c',
    },
    drawer: {
      main: '#0068a8',
      contrastText: '#fff'
    },
    drawerId: {
      hover: '#00588e',
      main: '#00588e',
      contrastText: '#fff'
    },
    drawerNav: {
      hover: '#00588e',
      main: '#00588e',
      contrastText: '#fff'
    },
    drawerLogo: {
      main: '#fff',
    },
    orange: {
      main: '#ff4c00',
      contrastText: '#fff',
    },
    success: {
      main: '#2ecc71',
      dark: '#2abc68',
      darker: '#208c4e',
      contrastText: '#fff',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    background: {
      paper: '#fff',
      default: '#F2F2F2',
      //appBar: '#fff',
      //drawer: '#0068a8',
      //drawerId: '#00588e',
      contrastText: '#000',
    },
    action: {

    }
  },
});

export const darkTheme = createTheme({
  // body: {
  //   backgroundColor: "#333333 !important",
  //   color: "#fff"
  // },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        input: ({ theme }) => ({
          "&.Mui-disabled": {
            opacity: 1,
            "-webkit-text-fill-color": theme.palette.grey.light+' !important',
            pointerEvents: "auto"
          }
        })
      }
    }
  },
  typography: {
   fontFamily: `futura-pt, "Helvetica", "Arial", sans-serif`,
   fontSize: 16,
   // "fontWeightLight": 300,
   // "fontWeightRegular": 400,
   // "fontWeightMedium": 500
  },
  palette: {
    mode: 'dark',
    type: 'dark',
    common: {
      black: '#000',
      grey: '#555',
      green: '#2ecc71',
      white: '#fff'
    },
    primary: {
      light: '#52bdff',
      main: '#2aaeff',
      dark: '#0088db',
      darker: '#00588e',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7fad',
      //main: '#f50057',
      //dark: '#c51162',
      main: '#d7136b',
      dark: '#ae0f56',
      contrastText: '#fff',
    },
    error: {
      lighter: '#ed9e9e',
      light: '#e57373',
      main: '#e57373',
      dark: '#d32f2f',
      contrastText: '#fff',
    },
    warning: {
      //light: '#ffb74d',
      main: '#ff8c4f',
      //dark: '#f57c00',
      contrastText: '#fff',
    },
    info: {
      light: '#469af5',
      main: '#2185f3',
      dark: '#0c72e0',
      contrastText: '#fff',
    },
    grey: {
      light: '#efefef',
      main: '#dfdfdf',
      dark: '#afafaf',
      darkest: '#fff',
      contrastText: '#fff',
    },
    ltgrey: {
      light: '#efefef',
      main: '#dfdfdf',
      dark: '#a1a1a1',
      contrastText: '#fff',
    },
    employ: {
      light: '#dffcfd',
      main: '#10c8cd',
      dark: '#0da4a9',
      contrastText: '#fff',
    },
    incorp: {
      light: '#feeece',
      main: '#f9ac0f',
      dark: '#db9505',
      contrastText: '#fff',
    },
    ltblue: {
      // light: '#64b5f6',
      main: '#4bbbff',
      // dark: '#1976d2',
      contrastText: '#000',
    },
    bgblue: {
      // light: '#64b5f6',
      main: '#555555',
      // dark: '#1976d2',
      contrastText: '#000',
    },
    bggrey: {
      // light: '#64b5f6',
      main: '#fafafa',
      // dark: '#1976d2',
      contrastText: '#000',
    },
    tablehead: {
      main: '#494949',
      contrastText: '#fff',
    },
    tablerow: {
      main: '#666',
      dark: '#555',
      contrastText: '#fff',
    },
    tablerowalt: {
      main: '#777',
      contrastText: '#fff',
    },
    appBar: {
      main: '#494949',
      contrastText: '#efefef'
    },
    drawer: {
      main: '#494949',
      contrastText: '#efefef'
    },
    drawerId: {
      hover: '#333333',
      main: '#333333',
      contrastText: '#52bdff' //'#adefad'
    },
    drawerNav: {
      hover: '#333333',
      main: '#333333',
      contrastText: '#efefef'
    },
    drawerLogo: {
      main: '#efefef',
    },
    orange: {
      main: '#ff4c00',
      contrastText: '#fff',
    },
    success: {
      main: '#388e3c',
      dark: '#328036',
      darker: '#2d7230',
      contrastText: '#fff',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    background: {
      paper: '#494949',
      default: '#3e3e3e',

      contrastText: '#fff'
    },
  },
});
